import { React } from "react";
import Payments from "../../components/documenty/payment/Payments";





function PaymentPage(props) {
  return (
    <>
    <Payments />
    </>
  );
}

export default PaymentPage;
